import { Component, OnInit, ChangeDetectorRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Products } from '../../../core/services/products.service';
import { Carts } from '../../../core/services/carts.service';
import { Product } from '../../../shared/models/Product';

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-detail.html',
  styleUrl: './product-detail.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductDetail implements OnInit {

  product: any = null;
  selectedSize: string = '';
  currentImage: string | null = null;
  quantity: number = 1;
  isLoading: boolean = true;
  selectedStock: number = 0;
  displayPrice: number = 0;
  displayPriceOffer: number = 0;
  isOfferActive: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private productService: Products,
    public cartService: Carts,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    const slug = this.route.snapshot.paramMap.get('slug');
    if (slug) {
      this.loadProduct(slug);
    } else {
      this.router.navigate(['/shop']);
    }
  }

  loadProduct(slug: string) {
    this.isLoading = true;
    this.productService.getProductBySlug(slug).subscribe({
      next: (data) => {
        this.product = data;
        this.currentImage = this.product.image;

        this.displayPrice = this.product.price;
        this.isOfferActive = !!this.product.isOffer && !!this.product.priceOffer
          && this.product.priceOffer > 0 && this.product.priceOffer < this.product.price;
        this.displayPriceOffer = this.isOfferActive ? this.product.priceOffer : 0;

        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.router.navigate(['/shop']);
      }
    });
  }

  selectSize(sizeName: string) {
    this.selectedSize = sizeName;
    this.quantity = 1;

    if (this.product && this.product.stockDetails) {
      const detail = this.product.stockDetails.find((s: any) => s.sizeName === sizeName);

      if (detail) {
        this.selectedStock = detail.quantity;
        this.displayPrice = detail.price || this.product.price;

        if (this.product.offerScope === 'BY_SIZE') {
          if (detail.discountValue > 0) {
            this.isOfferActive = true;
            this.displayPriceOffer = detail.discountType === '%'
              ? this.displayPrice * (1 - detail.discountValue / 100)
              : this.displayPrice - detail.discountValue;
          } else {
            this.isOfferActive = false;
          }
        } else if (this.product.offerScope === 'GLOBAL' && this.product.isOffer) {
          const globalVal = this.product.globalDiscountValue || 0;
          if (globalVal > 0) {
            this.isOfferActive = true;
            this.displayPriceOffer = this.product.globalDiscountType === '%'
              ? this.displayPrice * (1 - globalVal / 100)
              : this.displayPrice - globalVal;
          } else {
            this.isOfferActive = false;
          }
        } else {
          this.isOfferActive = false;
        }

        if (this.isOfferActive && this.displayPriceOffer <= 0) {
          this.isOfferActive = false;
        }
      }
    }
    this.cdr.detectChanges();
  }

  increaseQty() {
    if (this.quantity < this.selectedStock) {
      this.quantity++;
    }
  }

  decreaseQty() {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  get isAddToCartDisabled(): boolean {
    if (!this.product || this.product.stock <= 0) return true;
    return (this.product.sizeNames?.length > 0) && !this.selectedSize;
  }

  addToCart() {
    if (!this.product || this.isAddToCartDisabled) return;

    const finalPrice = this.isOfferActive ? this.displayPriceOffer : this.displayPrice;

    this.cartService.addToCart(
      this.product.id,
      this.quantity,
      this.selectedSize,
      this.product.colorName || this.product.color,
      finalPrice
    );
  }

  isSizeOutOfStock(sizeName: string): boolean {
    if (!this.product?.stockDetails) return false;
    const detail = this.product.stockDetails.find((s: any) => s.sizeName === sizeName);
    return detail ? detail.quantity === 0 : false;
  }
}